import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../api";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  const handleVerify = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await api.post(
        "/verify-otp",
        {
          email,
          otp,
        }
      );

      if (response.data.status) {

        toast.success("OTP Verified");

        navigate("/reset-password", {
          state: {
            email,
            otp,
          },
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "Invalid OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setResending(true);

      const res = await api.post("/forgot-password", {
        email,
      });

      if (res.data.status) {
        toast.success("OTP sent successfully.");
      } else {
        toast.alert(res.data.message);
      }
    } catch (error) {
      toast.alert(
        error?.response?.data?.message ||
        "Failed to resend OTP"
      );
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex justify-center items-center p-4">

      <div className="w-full max-w-md bg-[#17130d] border border-[#D4AF37] rounded-2xl p-6">

        <h2 className="text-2xl font-bold text-[#D4AF37] mb-6">
          Verify OTP
        </h2>

        <form onSubmit={handleVerify}>
          <input
            type="text"
            required
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            className="w-full p-3 rounded-xl bg-black border border-[#6f5517] text-white"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-4 bg-[#D4AF37] text-black font-bold py-3 rounded-xl"
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </form>

        <div className="text-center mt-4">
          <button
            type="button"
            onClick={handleResendOtp}
            disabled={resending}
            className="
              text-[#C79D17]
              font-semibold
              hover:underline
              disabled:opacity-50
            "
          >
            {resending ? "Sending..." : "Resend OTP"}
          </button>
        </div>

      </div>

    </div>
  );
};

export default VerifyOtp;